/* eslint-disable jsx-a11y/alt-text */
// footer
import Footer from "../../../layouts/template/charge/footer/footer";
// hook
import { useEffect, useState } from "react";
// cookie
// @ts-ignore
import Cookies from 'js-cookie';
// splitter
import { splitNumber } from "../../../features/splitNumber/splitNumber";
import { useParams } from "react-router-dom";
// layouts

const SuccessPayment = () => {
    const [user, setUser] = useState<object | any>();
    const { reference } = useParams();
    const { tracking } = useParams();
    const [status, setStatus] = useState<boolean>(false);
    useEffect(() => {
        document.getElementById('site-main')?.classList.remove('main-content')
        document.getElementById('site-main')?.classList.add('bg-payment-new')
        document.getElementById('site-main')?.classList.add('bg-white')
        let user: any = Cookies.get('userData');
        user = JSON.parse(user);
        if (user?.isWallet === false) {
            setStatus(true)
        } else {
            setStatus(false)
        }
        setUser(user);
    }, []);
    const now = new Date();

    const formatter = new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });

    const formatted = formatter.format(now);
    return (
        <>
            <article className={'payment h-100 overflow-x-hidden'}>
                <div className="row justify-content-center h-100">
                    <header className={'container text-center'}>
                        <div className="top-bar" style={{ paddingBottom: '15px' }}>
                            <div className="d-flex justify-content-center">
                                <img alt="logo" src={require('./../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                            </div>
                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>
                    <div className="col-12">
                        <div id={'text-field'}>
                            <section style={{ marginTop: '-100px' }} className={'profile container'}>
                                <div className={'profile-items d-flex justify-content-center text-center'}>
                                    {status ?
                                        (
                                            <>
                                                {user?.image ? (
                                                    <>
                                                        <img className={'profile-img-valid'} src={user.image} />
                                                    </>
                                                ) : (
                                                    <>
                                                        {user?.urlName === 'Shufti' ?
                                                            (
                                                                <img src={require('./../../../assets/media/logo/sh.png')} alt="" style={{ width: '100px', height: '80px' }} className='mt-3' />
                                                            )
                                                            : (
                                                                <>
                                                                    <img
                                                                        className="profile-img-valid"
                                                                        src={require('./../../../assets/media/images/payment/Profile_Vr_01 1.png')} />
                                                                </>
                                                            )}
                                                    </>
                                                )}
                                            </>
                                        ) :
                                        (
                                            <>
                                                <h5 className={'text-site text-center mt-1 fw-bold'}>
                                                    شارژ حساب کاربری ایران تراکنش
                                                </h5>
                                            </>
                                        )
                                    }
                                </div>
                                {Cookies.get("irt") === "true" ?
                                    <>
                                        {status ?
                                            (
                                                <>
                                                    <p className={'fw-bold text-center mt-3 mb-1'}>
                                                        <span className={'ms-1'}>
                                                            {user?.firstName}
                                                        </span>
                                                        {user?.lastName}
                                                    </p>
                                                </>
                                            ) : null}
                                    </>
                                    :
                                    <>
                                        {!status ?
                                            (
                                                <></>
                                            ) :
                                            <>
                                                <p className={'fw-bold text-center mt-3 mb-1'}>
                                                    <span>
                                                        {user?.irtName}
                                                    </span>
                                                </p>
                                            </>
                                        }
                                    </>
                                }

                                {user?.urlName !== 'Shufti' ?
                                    (
                                        <p className={'text-muted text-center mb-2'}>
                                            {status ? user?.merchantCode : `${user?.mobile}`}
                                        </p>
                                    )
                                    : null}
                            </section>
                            <section className={'bg-white text-center py-1 my-2 mt-1'}>
                                <p className={'fw-bold h5'}>
                                    <span className={'price-amount ms-1'}>
                                        {Cookies.get("irt") === "true" ?
                                            <>
                                                {splitNumber(user?.payablePrice / 10)}
                                            </>
                                            :
                                            <>
                                                {splitNumber(status ? ((user?.price + user?.currentBalance)) / 10 : (user?.price) / 10)}
                                            </>
                                        }
                                    </span>
                                    تومان
                                </p>
                                {status ? (
                                    <>
                                        <span className="badge bg-success-site mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                            با موفقیت به پذیرنده فوق پرداخت شد
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span className="badge bg-success-site mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                            موجودی حساب کاربری شما افزایش یافت
                                        </span>
                                    </>
                                )}
                                <div>
                                    {status ? (
                                        <span
                                            style={{ fontSize: "14px" }}
                                            className="badge btn-site mt-3 px-5"
                                        >
                                            برداشت از کارت بانکی شما
                                            <span className="mx-1">
                                                {(user?.price) / 10}
                                            </span>
                                            تومان
                                        </span>
                                    ) : null}
                                </div>
                            </section>
                            <div className="px-4">
                                <ul className="list-group font-small list-group-flush mt-4 px-0">
                                    {status ? null : (<>
                                        <li className="list-group-item px-0">
                                            <div className="d-flex justify-content-between">
                                                <span className="text-muted">
                                                    {status ? 'مبلغ برداشت شده از کارت بانکی با احتساب کارمزد' : '  موجودی فعلی ایران تراکنشی شما'}
                                                </span>
                                                <p className={'price fw-bold mb-0 dark-green card-text'}>
                                                    <span className={'price-amount ms-1'}>
                                                        {splitNumber(status ? user?.price / 10 : ((user?.price + user?.currentBalance) - user?.wage) / 10)}
                                                    </span>
                                                    تومان
                                                </p>
                                            </div>
                                            <hr />
                                        </li>
                                    </>)}
                                    <li className="list-group-item border px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                زمان
                                            </span>
                                            <span className="fw-bold">
                                                {formatted}
                                            </span>
                                        </div>
                                        <hr />
                                    </li>
                                    <li className="list-group-item border px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                شماره پیگیری
                                            </span>
                                            <span className="fw-bold">
                                                {tracking}
                                            </span>
                                        </div>
                                        <hr />
                                    </li>
                                    <li className="list-group-item px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                شماره مرجع
                                            </span>
                                            <span className="fw-bold">
                                                {reference}
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* footer */}
                        <Footer status={status} />
                    </div>
                </div>
            </article>
        </>
    )
}

export default SuccessPayment;